import type { MemberPermissionKey } from "@open-booking/shared";
import { useGetMyTeamContextQuery } from "@/src/owner/services/team-http.service";

export function usePropertyPermission(propertyId: string | undefined, permission: MemberPermissionKey): boolean {
	const { data: teamContext } = useGetMyTeamContextQuery();
	if (!teamContext) return false;
	if (teamContext.role === "owner") return true;
	if (!propertyId) return false;
	const membership = teamContext.memberships.find((m) => m.property_id === propertyId);
	return Boolean(membership?.permissions[permission]);
}

export function useTeamPermission(permission: MemberPermissionKey): boolean {
	const { data: teamContext } = useGetMyTeamContextQuery();
	if (!teamContext) return false;
	if (teamContext.role === "owner") return true;
	return teamContext.memberships.some((m) => m.permissions[permission]);
}
